import * as Yup from 'yup';
import i18n from '../../i18n/i18n';

export const loginSchema = Yup.object().shape({
  UserName: Yup.string()
    .required(() => i18n.t('validation.emailOrRegistrationNumberIsRequired'))
    .test(
      'email-or-username',
      () => i18n.t('validation.enterAValidEmailOrRegistration'),
      (value) => {
        if (!value) return false;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // only treat as email if it has @ and a dot after it (real email pattern)
        const looksLikeEmail =
          value.includes('@') &&
          value.substring(value.indexOf('@')).includes('.');

        if (looksLikeEmail) {
          return emailRegex.test(value);
        }

        // allow usernames like abc@, student@12, REG123
        return true;
      }
    ),

  Password: Yup.string()
    .min(6, () => i18n.t('validation.passwordMustBeAtLeast6'))
    .max(50, () => i18n.t('validation.passwordMustBeAtMost50'))
    .required(() => i18n.t('validation.passwordIsRequired')),
});
